import { useSearchParams, useNavigate } from 'react-router-dom';
import { useEntitlements } from '../hooks/useEntitlements';

// Paywall page - Shows when user tries to access a course they don't own
// NOTE: This route (/paywall) exists but is currently unused. The PaywallModal
// is the active paywall component used via PaywallContext.
export function Paywall() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { courseCodes } = useEntitlements();

  const course = searchParams.get('course');

  // Product information
  const products = {
    phonics: {
      name: 'Phonics Course',
      sku: 'phonics_lifetime',
      price: '¥199',
      description: 'Learn English phonics with interactive lessons'
    },
    southstreet: {
      name: 'South Street Course',
      sku: 'southstreet_lifetime',
      price: '¥199',
      description: 'Master conversational English through engaging stories'
    },
    all: {
      name: 'All Courses (Monthly Subscription)',
      sku: 'all_courses_monthly',
      price: '¥29.90/month',
      description: 'Access all courses with a monthly subscription'
    }
  };

  const handlePurchase = (sku) => {
    // TODO: Integrate with WeChat Pay / Alipay
    alert(`Payment integration coming soon!\nProduct: ${sku}`);
  };

  const getCourseDisplayName = (courseCode) => {
    const names = {
      phonics: 'Phonics',
      southstreet: 'South Street'
    };
    return names[courseCode] || courseCode;
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '40px',
        maxWidth: '600px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>🔒</div>
          <h1 style={{ margin: '0 0 10px 0', fontSize: '32px', color: '#333' }}>
            Access Required
          </h1>
          <p style={{ margin: 0, fontSize: '18px', color: '#666' }}>
            You need to purchase access to the{' '}
            <strong style={{ color: '#667eea' }}>
              {getCourseDisplayName(course)}
            </strong>{' '}
            course
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ marginBottom: '20px', fontSize: '20px', color: '#333' }}>
            Your Current Access:
          </h3>
          {courseCodes.length > 0 ? (
            <div style={{
              background: '#f0fdf4',
              border: '1px solid #86efac',
              borderRadius: '8px',
              padding: '12px',
              marginBottom: '16px'
            }}>
              ✅ {courseCodes.map(getCourseDisplayName).join(', ')}
            </div>
          ) : (
            <div style={{
              background: '#fef2f2',
              border: '1px solid #fca5a5',
              borderRadius: '8px',
              padding: '12px',
              marginBottom: '16px'
            }}>
              ❌ No courses yet
            </div>
          )}
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ marginBottom: '20px', fontSize: '20px', color: '#333' }}>
            Available Products:
          </h3>

          {/* Individual course products */}
          {course === 'phonics' && (
            <ProductCard
              product={products.phonics}
              onPurchase={handlePurchase}
            />
          )}

          {course === 'southstreet' && (
            <ProductCard
              product={products.southstreet}
              onPurchase={handlePurchase}
            />
          )}

          {/* All courses subscription */}
          <ProductCard
            product={products.all}
            onPurchase={handlePurchase}
            featured
          />
        </div>

        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#667eea',
              fontSize: '16px',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            ← Go Back
          </button>
        </div>
      </div>
    </div>
  );
}

function ProductCard({ product, onPurchase, featured = false }) {
  return (
    <div style={{
      border: featured ? '2px solid #667eea' : '1px solid #e5e7eb',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '16px',
      background: featured ? '#f5f3ff' : 'white',
      position: 'relative'
    }}>
      {featured && (
        <div style={{
          position: 'absolute',
          top: '-12px',
          right: '20px',
          background: '#667eea',
          color: 'white',
          padding: '4px 12px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: 'bold'
        }}>
          BEST VALUE
        </div>
      )}

      <h4 style={{ margin: '0 0 8px 0', fontSize: '18px', color: '#333' }}>
        {product.name}
      </h4>
      <p style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#666' }}>
        {product.description}
      </p>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#667eea'
        }}>
          {product.price}
        </span>
        <button
          onClick={() => onPurchase(product.sku)}
          style={{
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.background = '#5568d3'}
          onMouseLeave={(e) => e.target.style.background = '#667eea'}
        >
          Purchase
        </button>
      </div>
    </div>
  );
}
